/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDepositPaymentDetail_item$ref: FragmentReference;
export type PdpSharedDepositPaymentDetail_item = {|
  +serviceId: ?string,
  +isDepositAvailable: boolean,
  +$refType: PdpSharedDepositPaymentDetail_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDepositPaymentDetail_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isDepositAvailable",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId",
          "type": "String"
        }
      ],
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2b79e2b42ebb3c9746128ed3d5a4f7b0';
module.exports = node;
